import { render, staticRenderFns } from "./pod_detail.vue?vue&type=template&id=d8561432"
import script from "./pod_detail.vue?vue&type=script&lang=js"
export * from "./pod_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports